"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordpressConnectRequestSchema = void 0;
const v4_1 = require("zod/v4");
const zod_1 = require("../zod");
exports.WordpressConnectRequestSchema = v4_1.z.object({
    website: zod_1.ZodHttpURLRoot,
});
